<script lang="ts">
  import { fade } from 'svelte/transition';

  import Icon from './icon/icon.svelte';

  import { cn } from '$lib/utils';

  import type { HTMLInputAttributes } from 'svelte/elements';
  import { input } from './common';
  import { createEventDispatcher } from 'svelte';
  import Link from './link.svelte';

  interface $$Props extends HTMLInputAttributes {
    error?: boolean;
    class?: string;
    value?: string;
    label?: string;
    helpButton?: string;
    name?: string;
    ref?: HTMLInputElement;
    inputClass?: string;
  }

  const dispatch = createEventDispatcher<{ help: undefined }>();

  let className: string | undefined = undefined;
  export { className as class };

  export let value: $$Props['value'] = '';
  export let error: $$Props['error'] = false;
  export let label: $$Props['label'] = undefined;
  export let helpButton: $$Props['helpButton'] = undefined;
  export let name: $$Props['name'] = undefined;
  export let ref: $$Props['ref'] = undefined;
  export let inputClass: $$Props['inputClass'] = undefined;
</script>

<div class={cn('relative', className)}>
  {#if label || helpButton}
    <div class="flex justify-between mb-2">
      {#if label}
        <label for={name} class="inline-block text-sm font-semibold">{label}</label>
      {/if}

      {#if helpButton}
        <Link as="button" type="button" class="text-sm" on:click={() => dispatch('help')}
          >{helpButton}</Link
        >
      {/if}
    </div>
  {/if}
  <div class="relative">
    <input
      {name}
      bind:value
      on:change
      on:mouseenter
      on:mouseleave
      on:click
      on:focus
      on:blur
      on:input
      bind:this={ref}
      class={cn(input({ error }), inputClass)}
      {...$$restProps}
    />
    {#if error}
      <div
        transition:fade={{ duration: 150 }}
        class="absolute bottom-1/2 right-3 top-1/2 flex -translate-y-1/2 items-center text-danger"
      >
        <Icon icon="alert" size="md" />
      </div>
    {/if}
  </div>
</div>
